module.exports = __webpack_public_path__ + "img/19_BC20_get_wetter.a52a6d53.jpg";